var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:\"sourceBlod\";src:url(" + escape(require("./SourceHanSansCN-Bold.otf")) + ");font-weight:normal;font-style:normal}\n", ""]);

// exports
